import type { SVGProps } from 'react';

export function FishIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.969 7.706C9.439 6.47 11.422 5.4 13.8 5.4c2.377 0 4.361 1.069 5.831 2.306 1.467 1.238 2.509 2.715 3.038 3.743.176.345.176.753 0 1.098-.529 1.028-1.572 2.505-3.038 3.743-1.47 1.241-3.45 2.306-5.831 2.306s-4.361-1.069-5.831-2.306a13 13 0 0 1-1.602-1.616l-3.363 1.96a1.202 1.202 0 0 1-1.65-1.63L3.075 12 1.357 8.996a1.202 1.202 0 0 1 1.65-1.631l3.364 1.961c.458-.547.994-1.102 1.601-1.616zM18 12a1.199 1.199 0 1 0-2.4 0c0 .664.536 1.2 1.2 1.2S18 12.664 18 12" />
    </svg>
  );
}
